import React from 'react';
import type { DefaultSegmentTemplate } from '../default-segment-templates';
import styles from './CreateSegmentDialog.module.css';

interface SegmentTemplateCardProps {
  template: DefaultSegmentTemplate;
  onSelect: (templateName: string) => void;
}

export const SegmentTemplateCard: React.FC<SegmentTemplateCardProps> = ({
  template,
  onSelect,
}) => {
  return (
    <button
      type="button"
      className={styles.templateButton}
      onClick={() => onSelect(template.name)}>
      <header>
        <h3>{template.displayName}</h3>
        <p>{template.description}</p>
      </header>
      <span className={styles.useTemplateText}>Use Template →</span>
    </button>
  );
};
